
export interface PersistState {
  grid_layout: PersistGrid;
  old_grid_layout: PersistGrid;
  font_layout: PersistFont;
  mobile_tab: string;
  current_breakpoint: string,
  ordersFilter: string;
  locked_layout: boolean;
  showDepositWalletInfo: boolean,
  showExpiredTKInfo: string,
  delistedPairsChecked: Array<number>,
  presalePairChecked: Array<number>,
  selectedPairId: number,
  depthOption: boolean,
  favPairList: Array<{address: string, pair_key:string}>,
}

interface PersistFont {
  minFont: number;
  openOrder: number;
  tableBody: number;
  tableHead: number;
  tickerArrow: number;
  tickerHead: number;
  tickerPrice: number;
}

export interface PersistGrid {
  lg: GridItem[];
  md: GridItem[];
  sm: GridItem[];
  xs: GridItem[];
}

export interface GridItem {
  i: string;
  x: number;
  y: number;
  h: number;
  w: number;
  minH?: number;
  minW?: number;
  isDraggable?: boolean;
  isResizable?: boolean;
  resizeHandles?: Array<string>;
}

export interface SystemState {
  maintenance_mode: number,
  scheduledDate: Date | null,
  new_version: boolean,
  notifications: UserNotification[],
  notificationsUnreadCount: number
}
export interface UserNotification {
  id: number,
  globalNotificationId: number,
  priority: NotificationPriorityEnum,
  status: NotificationStatusEnum,
  type: NotificationTypeEnum,
  message: string,
  createdAt: Date,
}

export enum NotificationStatusEnum {
  UNREAD = 'UNREAD',
  READ = 'READ',
}

export enum NotificationPriorityEnum {
  CRITICAL = 'CRITICAL',
  IMPORTANT = 'IMPORTANT',
  INFO = 'INFO',
}

export enum NotificationTypeEnum { 
  GLOBAL_PAIR_DELISTING = 'GLOBAL_PAIR_DELISTING', 
  GLOBAL_NEW_PAIR_LISTING = 'GLOBAL_NEW_PAIR_LISTING', 
  GLOBAL_SYSTEM_MAINTENANCE = 'GLOBAL_SYSTEM_MAINTENANCE', 
  GLOBAL_SMART_CONTRACT_UPDATE = 'GLOBAL_SMART_CONTRACT_UPDATE', 
  ACCOUNT_POINTS_UNLOCK_ACHIEVEMENT = 'ACCOUNT_POINTS_UNLOCK_ACHIEVEMENT', 
  ACCOUNT_KYC_STATUS_CHANGED = 'ACCOUNT_KYC_STATUS_CHANGED' 
}